<script>
    /**
     * 按钮
     */
    export default {
        name: 'normal-button',
        props: {
            icon: {
                default: '',
                required: false
            },
            text: {
                default: '',
                required: false
            },
            theme: {
                default: 'grey',
                required: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            blank: {
                default: false,
                required: false
            },
            url: {
                default: '#',
                required: false
            },
            loading: {
                required: false,
                default: false
            }
        },
        methods: {
            click () {
                if (!this.disabled) {
                    this.$emit('click');
                }
            }
        },
        computed: {
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float
                };
            }
        },
        mounted () {
        }
    };
</script>

<template>
    <a v-if="blank"
       class="button"
       :class="[theme, {disabled: disabled}]"
       :style="curStyle"
       target="_blank"
       :href="url"
    >
        <span class="icon" :class="{loading : loading}" v-show="icon.length > 0 || loading"
              v-html="loading ? '&#xe6ac;' : icon"></span>
        <template v-if="$slots.default">
            <slot></slot>
        </template>
        <template v-else>
            <span class="text" v-show="text.length > 0" v-html="text"></span>
        </template>
    </a>
    <div v-else class="button"
         :class="[theme, {disabled: disabled}]"
         :style="curStyle"
         @click="click"
    >
        <span class="icon" :class="{loading : loading}" v-show="icon.length > 0 || loading"
              v-html="loading ? '&#xe6ac;' : icon"></span>
        <template v-if="$slots.default">
            <slot></slot>
        </template>
        <template v-else>
            <span class="text" v-show="text.length > 0" v-html="text"></span>
        </template>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .button {
        box-sizing: border-box;
        border-radius: @widgetsBorderRadius;
        display: block;
        width: auto;
        min-width: 1px;
        height: @widgetsHeight;
        line-height: @widgetsHeight;
        text-align: center;
        border: 1px @otherBtnBorderNoteClr solid;
        overflow: hidden;
        padding: 0 15px;
        margin: (@lineHeight - @widgetsHeight)/2 0;
        position: relative;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        user-select: none;

        * {
            user-select: none;
        }

        &.disabled {
            background-color: @otherDisabledBgClr !important;
            color: @otherBtnBorderNoteClr !important;
            border: 1px solid @otherBorderClr !important;
            cursor: not-allowed;
        }

        > .icon {
            font-family: cmsicon;
            margin-right: 5px;
            display: inline-block;

            &.loading {
                line-height: 14px;
                height: 14px;
                width: 14px;
                transition: all 0.36s ease-in-out;
                -moz-animation: spin 2s infinite linear;
                -o-animation: spin 2s infinite linear;
                -webkit-animation: spin 2s infinite linear;
                animation: spin 2s infinite linear;

            }
        }
    }

    .button, .button.grey {
        background-color: @whiteBg;
        color: @otherTextClr;

        &:hover {
            color: @primaryBg;
            border: 1px solid @primaryBg;
        }
    }

    .button.blue, .button.primary {
        border: 1px solid @primaryBg;
        background-color: @primaryBg;
        color: @whiteBg;

        &:hover {
            border: 1px solid @primaryActiveBg;
            background-color: @primaryActiveBg;
            color: @otherIptSelTipsDisbaledClr;
        }

        &.disabled {
            background-color: @primaryDisabledBg !important;
            color: @whiteBg !important;
            border: 1px solid @primaryDisabledBg !important;
            cursor: not-allowed;
        }

    }

    .button.normal {
        border: 1px solid @otherBtnBorderNoteClr;
        background-color: @otherBtnBorderNoteClr;
        color: @whiteBg;

        &:hover {
            border: 1px solid @otherIptSelTipsDisbaledClr;
            background-color: @otherIptSelTipsDisbaledClr;
            color: @whiteBg;
        }

        &.disabled {
            background-color: @otherDisabledBgClr !important;
            color: @whiteBg !important;
            border: 1px solid @otherDisabledBgClr !important;
            cursor: not-allowed;
        }

    }

    .button.danger {
        border: 1px solid @dangerBg;
        background-color: @dangerBg;
        color: @whiteBg;

        &:hover {
            border: 1px solid @dangerActiveBg;
            background-color: @dangerActiveBg;
            color: @otherIptSelTipsDisbaledClr;
        }

        &.disabled {
            background-color: @dangerDisabledBg !important;
            color: @whiteBg !important;
            border: 1px solid @dangerDisabledBg !important;
            cursor: not-allowed;
        }

    }

    .button.warn {
        border: 1px solid @warnBg;
        background-color: @warnBg;
        color: @whiteBg;

        &:hover {
            border: 1px solid @warnActiveBg;
            background-color: @warnActiveBg;
            color: @otherIptSelTipsDisbaledClr;
        }

        &.disabled {
            background-color: @warnDisabledBg !important;
            color: @whiteBg !important;
            border: 1px solid @warnDisabledBg !important;
            cursor: not-allowed;
        }

    }

    .button.blue-text {
        background-color: rgba(0, 0, 0, 0);
        color: @primaryBg;
        border-color: rgba(0, 0, 0, 0);
    }

    .button.blueicon {
        padding: 0;
        border-color: #fff;
        background-color: #fff;

        > .icon {
            color: #015ac3;
        }

        > .text {
            font-weight: bold;
        }
    }

    .button.onlyicon {
        width: 26px;
        padding: 0;
        border-color: #fff;
    }

    .button.no-border {
        border: none;
        background-color: transparent;
        padding: 0;

        &:hover {
            color: #11a1f8;
        }
    }

</style>
